import { useApp } from '../../context/AppContext';
import { formatFileSize } from '../../utils/fileUtils';
import './Sidebar.css';

const Sidebar = () => {
  const { uploadedFiles, currentFile, setCurrentFile, setCurrentView, removeFile } = useApp();

  const handleFileSelect = (file) => {
    setCurrentFile(file);
    setCurrentView('view');
  };

  if (uploadedFiles.length === 0) {
    return null;
  }

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>Files ({uploadedFiles.length})</h3>
      </div>

      <div className="files-list">
        {uploadedFiles.map((file) => (
          <div
            key={file.id}
            className={`file-item ${currentFile?.id === file.id ? 'active' : ''}`}
            onClick={() => handleFileSelect(file)}
          >
            <div className="file-icon">📄</div>
            <div className="file-info">
              <div className="file-name" title={file.name}>
                {file.name}
              </div>
              <div className="file-size">{formatFileSize(file.size)}</div>
            </div>
            <button
              className="btn btn-ghost remove-file-btn"
              onClick={(e) => {
                e.stopPropagation();
                removeFile(file.id);
              }}
              title="Remove file"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
